"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNextJS = void 0;
const isNextJS = () => {
    var _a, _b;
    // Client side
    if (typeof window !== 'undefined') {
        return Boolean((window === null || window === void 0 ? void 0 : window.__NEXT_DATA__) || (window === null || window === void 0 ? void 0 : window.next));
    }
    // Server side
    return Boolean(((_a = process.env) === null || _a === void 0 ? void 0 : _a.__NEXT_PROCESSED_ENV) ||
        ((_b = process.env) === null || _b === void 0 ? void 0 : _b.NEXT_RUNTIME) ||
        (
        // @ts-expect-error internal nextJS attributes
        global === null || global === void 0 ? void 0 : global.__NEXT_LOADED_PAGES__));
};
exports.isNextJS = isNextJS;
//# sourceMappingURL=index.js.map